import { render, staticRenderFns } from "./MonitorManager.vue?vue&type=template&id=09a32135&scoped=true&"
import script from "./MonitorManager.vue?vue&type=script&lang=js&"
export * from "./MonitorManager.vue?vue&type=script&lang=js&"
import style0 from "./MonitorManager.vue?vue&type=style&index=0&id=09a32135&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a32135",
  null
  
)

export default component.exports